package com.shadowings.gero.data.lessons.chapter5
import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_vocab_verbs_2_alyn
import gero.composeapp.generated.resources.exp_content_vocab_verbs_2_nilo
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_vocab_verbs_2_intro
import gero.composeapp.generated.resources.exp_title_word_name

val vocabVerbs2WordIds = listOf("USCIRE", "ENTRARE", "AMARE", "ESISTERE", "VOLARE")

fun getVocabVerbs2Content(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_vocab_verbs_2_intro,
            content = Res.string.exp_content_vocab_verbs_2_nilo,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_vocab_verbs_2_intro,
            content = Res.string.exp_content_vocab_verbs_2_alyn,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
    )

    val slides = vocabVerbs2WordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Nilo,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    return intro + slides
}

fun getVocabVerbs2QuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode,
        additionalOptions = setOf("MANGIARE", "DARE")
    )
}


